import React from 'react'; 
import { IconButton, Tooltip } from '@material-ui/core';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete'; 
import InputAdornment from '@material-ui/core/InputAdornment'
import styles from './selectsearch.module.css'
import AddRoundedIcon from '@material-ui/icons/AddRounded';

const SelectSearch = (props) => { 
    return ( 
        <div className={`${props.className} ${styles.container}`}>
            <Autocomplete
                value={props.value}
                onChange={(event, newValue) => {
                    props.onChange(newValue)
                }} 
                options={props.options}
                
                getOptionLabel={(option) => option[props.keyCode]}
                style={{flex: 1}}

                renderInput={(params) =>  (
                    <React.Fragment>
                        {props.tooltip
                            ?
                        <Tooltip title={props.value[props.keyCode]}>
                            <TextField {...params} label={props.label} variant="outlined"  error={props.error} helperText={props.error} />  
                        </Tooltip>
                            :
                        <TextField {...params} label={props.label} variant="outlined"  error={props.error} helperText={props.error} />  }
                    </React.Fragment>
                )}
                renderOption={(option) => {
                    return (
                        <div className={styles.listItem}>
                            <p className={styles.head}>{option[props.keyCode]}</p>
                            {props.subHeading && <span className={styles.subHead}>{option.subHeading}</span>}
                        </div>
                    )
                }}



                noOptionsText={'Add New'}
            /> 
            {props.deleteIcon &&
            <InputAdornment position="end">
                <Tooltip title="Delete">
                    <IconButton onClick={props.onDelete}>
                        <DeleteRoundedIcon />
                    </IconButton>    
                </Tooltip>
            </InputAdornment>}

            {props.addIcon &&
            <InputAdornment position="end">
                <Tooltip title={props.onAddName}>
                    <IconButton onClick={props.onAdd}>
                        <AddRoundedIcon />
                    </IconButton>    
                </Tooltip>
            </InputAdornment>}
        </div>
    )
}

export default SelectSearch;